// 動作モードlocal以外
import user from './repository-user'
import login from './repository-login'
import cms from './repository-cms'
import coupon from './repository-coupon'
import search from './repository-search'
import plan from './repository-plan'
import order from './repository-order'
import menu from './repository-menu'
import benepoint from './repository-benepoint'
import cafe from './repository-cafe'
import stay from "./repository-stay";

// 動作モードlocal
import mock_user from './mock/repository-user'
import mock_login from './mock/repository-login'
import mock_cms from './mock/repository-cms'
import mock_coupon from './mock/repository-coupon'
import mock_search from './mock/repository-search'
import mock_plan from './mock/repository-plan'
import mock_order from './mock/repository-order'
import mock_menu from './mock/repository-menu'
import mock_benepoint from './mock/repository-benepoint'
import mock_cafe from './mock/repository-cafe'
import mock_stay from "./mock/repository-stay";

// モード：mockかどうか
const mode = process.env.NODE_ENV === 'local' ? 'mock' : ''
// const mode = ''

// 動作モードlocal以外
const repository = {
  user,
  login,
  cms,
  coupon,
  search,
  plan,
  order,
  menu,
  benepoint,
  cafe,
  stay
}

// 動作モードlocal
const mock_repository = {
  mock_user,
  mock_login,
  mock_cms,
  mock_coupon,
  mock_search,
  mock_plan,
  mock_order,
  mock_menu,
  mock_benepoint,
  mock_cafe,
  mock_stay
}

// 動作モードがlocalの場合はrepositoryの矛先を変更する
const repositories = mode === 'mock' ? mock_repository : repository

export const RepositoryFactory = {
  get: (name) => {
    const repositoryName = mode === 'mock' ? `mock_${name}` : name
    return (
      repositories[repositoryName] ||
      console.error(`${repositoryName} repository is not found.`)
    )
  }
}
